import axios from 'axios'
import CreateProgramType from './dto/CreateProgramType'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedProgramTypeResultRequestDto} from './dto/PagedProgramTypeResultRequestDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import GetAllProgramTypes from './dto/GetAllProgramTypes'
import UpdateProgramType from './dto/UpdateProgramType'
import GetProgramType from './dto/GetProgramType'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/ProgramType/Create`
export const URL_DELETE = `${API_URL}/ProgramType/Delete`
export const URL_GET = `${API_URL}/ProgramType/Get`
export const URL_GET_ALL = `${API_URL}/ProgramType/GetPagedAll`
export const URL_UPDATE = `${API_URL}/ProgramType/Update`

export function onCreateProgramType(createProgramType: CreateProgramType): Promise<boolean> {
  return axios.post(URL_CREATE, createProgramType)
}

export function onDeleteProgramType(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetProgramType(entityDto: EntityDto): Promise<GetProgramType> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllProgramTypes(
  pagedFilterAndSortedRequest: PagedProgramTypeResultRequestDto
): Promise<PagedResultDto<GetAllProgramTypes>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onUpdateProgramType(updateProgramTypeInput: UpdateProgramType): Promise<boolean> {
  return axios.put(URL_UPDATE, updateProgramTypeInput)
}
